import { InjectionToken } from "@angular/core";

import { IConfig } from "./interfaces";

export const YOUM_API_CONFIG_TOKEN = new InjectionToken<IConfig>("config");
